<template>
  <div class="detail-wrap" v-loading="loading">
    <div class="dn-content-bg" style="text-align: center;height:140px;display: flex;align-items: center;margin:5px;">
      <img style="width:310px;height:140px;" v-if="obj.messageJson.imageUrl" :src="'data:image/jpg;base64,'+obj.messageJson.imageUrl" />
      <label v-else style="font-size: 26px;color: #ccc;width:320px;display:inline-block;">暂无设备图片</label>
    </div>
    <div class="detail-content">
      <div class="item bold">{{obj.messageJson.name}}</div>
      <!-- <div class="item">
        <label class="span normal" v-show="obj.messageJson.state ==='正常'">正常</label>
        <label class="span abnormal" v-show="obj.messageJson.state ==='异常'">异常</label>
      </div>-->
      <!-- <div class="item">
        <label>租户名称:</label>
        <label class="text-abnormal">{{obj.messageJson.VoltageLevel}}</label>
      </div>-->
      <div>
        <div v-for="(item,index) in obj.messageJson.property" :key="index">
          <div class="item" v-if="index < 4">
            <label>{{item.displayName}}：</label>
            <label>{{item.value}}</label>
          </div>
        </div>
      </div>
      <div class="detail-foot" v-show="obj.messageJson.property.length > 4">
        <label @click="clickMore">
          更多信息
          <i class="el-icon-arrow-down"></i>
        </label>
      </div>
    </div>
    <div class="popup" v-if="showPopup">
      <div class="popup-content">
        <div class="popup-title">
          {{obj.messageJson.name}}
          <i style="    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 16px;
    cursor: pointer;" class="el-icon-close" @click="showPopup = false"></i>
        </div>
        <div style="
    height: 364px;
    padding: 10px;
    overflow: auto;
    box-sizing: border-box;
    position:relative;">
          <div class="item" v-for="(item,index) in obj.messageJson.property" :key="index">
            <label>{{item.displayName}}：</label>
            <label>{{item.value}}</label>
          </div>
          <div class="item-img">
            <img style="width:310px;height:240px;" v-if="obj.messageJson.imageUrl" :src="'data:image/jpg;base64,'+obj.messageJson.imageUrl" />
            <label v-else style="font-size: 26px;color: #ccc;">暂无设备图片</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@common/api/index.js";
export default {
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data () {
    return {
      loading: true,
      showPopup: false,
      enumData: [],
    };
  },
  watch: {
    "obj.messageJson" (val, oldValue) {
      this.getData(val);
    },
  },
  created () {
    api.enumClass.getSubEnumClasses2("", 0, 0).then((res) => {
      this.enumData = res.data;
      if (this.obj.messageJson) {
        this.getData(this.obj.messageJson);
      }
    });
  },
  methods: {
    getData (val) {
      if (Object.keys(val).length > 0) {
        const arr = ["isVirtual", "shield", "equipmentglDataItem", "equipmentglStatus", "equipmentglStatusJudge", "analysisUrl"]
        let property = [];
        for (let index = 0; index < val.property.length; index++) {
          let obj = val.property[index];
          if (
            arr.indexOf(obj.name) == -1 &&
            obj.name.indexOf("benchmarking") == -1
          ) {
            if (obj.regulation.valueType == 5) {
              const item = this.enumData.find((c) => c.name == obj.value);
              if (item) {
                obj.value = item.displayName;
              }
            }
            property.push(obj);
          }
        }
        this.obj.messageJson.property = property;
        this.loading = false;
      }
    },
    clickMore () {
      this.showPopup = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-wrap {
  width: 100%;
  height: 100%;
  .img {
    width: 100%;
    height: 140px;
    display: block;
    background: #f0f3f4;
  }
  .detail-content {
    padding: 5px;
    text-align: left;
    padding-bottom: 0px;
    .item {
      padding-top: 4px;
    }
    :first-child {
      padding-top: 0px;
    }
  }
}
.item-img {
  position: absolute;
  right: 5px;
  top: 5px;
}
.bold {
  font-size: 16px;
}
.span {
  display: inline-block;
  padding: 2px 4px;
  border-radius: 2px;
}
.span:first-child {
  margin-left: 0px;
}
.normal {
  background: #0097ee22;
  color: #0097ee;
}
.abnormal {
  background: #cf3b1322;
  color: #cf3b13;
}
.detail-foot {
  margin-top: 10px;
  border-top: 1px solid #cccccc;
  text-align: center;
  padding-bottom: 10px;
}
.detail-foot label {
  border: 1px solid #cccccc;
  border-top: 0px;
  margin-top: -1px;
  padding: 4px 6px;
  color: #0097ee;
  display: inline-block;
  background: #ffffff;
  cursor: pointer;
}
.popup-content {
  width: 500px;
  height: 286px;
  background: #ffffff;
}
.popup-title {
  background: #0197ee;
  height: 36px;
  box-sizing: border-box;
  padding: 0 10px;
  font-size: 16px;
  font-weight: bold;
  line-height: 36px;
  color: #ffffff;
  position: relative;
}
</style>